import { ref } from 'vue';
import { toast } from 'vue-sonner';

const  channels = ref([])
const loadingFetchChannels = ref(false);

export function useChannels() {
  const fetchChannels = async () => {
    loadingFetchChannels.value = true;
    try {
      const { data } = await axios.get('/api/v1/pbx/channels');
      channels.value = data.channels ?? [];
      return channels.value;
    } catch (e) {
      console.error(e);
      toast.error('Failed to fetch channels.');
    } finally {
      loadingFetchChannels.value = false;
    }
  };

  return {
    fetchChannels,
    channels,
    loadingFetchChannels,
  };
}
